import { indexOf } from 'lodash';
import { stageOrder, Stages } from '../../types/Stages';

export function stageOnOrAfter(stage: Stages, afterStage: Stages) {
  return indexOf(stageOrder, stage) >= indexOf(stageOrder, afterStage);
}
